import { helper } from '@ember/component/helper';

export function isV2Page(): boolean {
  return !!window.document?.body.querySelector('.v2-page');
}

export default helper(isV2Page);
